import { FC, ReactNode, useCallback, useState } from 'react';
import {
	AddListOfErrorsParams,
	ErrorsMaps,
	InputErrorContext,
} from '../context/InputErrorContext.tsx';
import { LagNavn } from '../Utils/types/DimensjoneringTypes.ts';

interface InputErrorContextProps {
	children: ReactNode;
}

export const InputErrorContextProvider: FC<InputErrorContextProps> = ({ children }) => {
	const [errors, setErrors] = useState<ErrorsMaps>([]);
	const updateListOfErrors = useCallback((params: AddListOfErrorsParams) => {
		const { listOfErrors, index } = params;
		const newErrors: Map<LagNavn, ('tykkelseMM' | 'materiale')[]> = new Map();
		listOfErrors.forEach(({ inputError }) => {
			if (inputError?.input && inputError?.lag) {
				const { input, lag } = inputError;
				newErrors.set(lag, [...(newErrors.get(lag) || []), input]);
			}
		});
		setErrors((prevState) => {
			const errorsCopy = [...prevState];
			errorsCopy[index] = newErrors;
			return errorsCopy;
		});
	}, []);

	const resetErrors = useCallback(() => {
		setErrors([]);
	}, []);

	const getErrorForField = useCallback(
		(field: LagNavn, index: number) => {
			return errors?.[index]?.get(field);
		},
		[errors]
	);

	return (
		<InputErrorContext.Provider
			value={{
				updateListOfErrors,
				errors,
				resetErrors,
				getErrorForField,
			}}
		>
			{children}
		</InputErrorContext.Provider>
	);
};
